/**
 * 作品案例 API 客户端
 */

export interface WorkCaseImage {
  file_type?: string | null
  file_address?: string | null
}

export interface WorkCaseSkill {
  skill_tag?: number | null
  skill_string?: string | null
}

export interface WorkCaseCarrier {
  carrier_tag?: number | null
  carrier_tag_string?: string | null
}

export interface WorkCaseIndustry {
  industry_tag?: number | null
  industry_tag_string?: string | null
}

export interface CoderBasic {
  id: number
  nickname?: string | null
  avatar?: string | null
}

export interface WorkCase {
  id: number
  case_name?: string | null
  title_worktype?: string | null
  excerpt?: string | null
  quality?: string | null
  status_string?: string | null
  coder?: CoderBasic | null
  images: WorkCaseImage[]
  skills: WorkCaseSkill[]
  carriers: WorkCaseCarrier[]
  industries: WorkCaseIndustry[]
}

export interface WorkCaseListResponse {
  data: WorkCase[]
  pagination: {
    total: number
    page: number
    page_size: number
    total_pages: number
  }
}

export interface WorkCaseFilters {
  industryTag?: number
  carrierTag?: number
  page?: number
}

/**
 * 获取作品案例列表
 */
export async function getWorkCases(
  filters: WorkCaseFilters = {}
): Promise<WorkCaseListResponse> {
  const params = new URLSearchParams()

  // industryTag: -1 表示全部，默认为 -1
  if (filters.industryTag !== undefined) {
    params.append('industryTag', filters.industryTag.toString())
  } else {
    params.append('industryTag', '-1')
  }

  // carrierTag: -1 表示全部，默认为 -1
  if (filters.carrierTag !== undefined) {
    params.append('carrierTag', filters.carrierTag.toString())
  } else {
    params.append('carrierTag', '-1')
  }

  // page: 默认为 1
  params.append('page', (filters.page || 1).toString())

  const baseUrl = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000'
  const url = `${baseUrl}/api/v1/work-cases?${params.toString()}`

  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`获取作品案例失败: ${response.statusText}`)
  }

  return response.json()
}

/**
 * 获取单个作品案例详情
 */
export async function getWorkCaseById(id: number): Promise<WorkCase> {
  const baseUrl = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000'
  const url = `${baseUrl}/api/v1/work-cases/${id}`

  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`获取案例详情失败: ${response.statusText}`)
  }

  return response.json()
}
